// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_v9-0";
export var checkoutRateBadgeLink = "_v9-1";